import { Record } from "immutable";

const CancelSubscriptionAccountStatsRecord = Record({
  projects: 0,
  tasks: 0,
  users: 0,
});

class CancelSubscriptionAccountStats extends CancelSubscriptionAccountStatsRecord {
  getNumberOfProjects() {
    return this.projects;
  }

  getNuberOfTasks() {
    return this.tasks;
  }

  getNumberOfUsers() {
    return this.users;
  }
}

export default CancelSubscriptionAccountStats;
